import React, { useCallback } from 'react';
import styled, { css } from 'styled-components';
import { forIE, forIPhone5, forDesktop } from '@westwing/ui-kit/breakPoints';
import { caption1 } from '@westwing/ui-kit/typography';
import WestwingNowLogo from '@westwing/ui-kit/Icons/WestwingNow';
import { textEllipsisCss } from '../Generic/Text/StyledText';
import useConfig from '../../hooks/useConfig';
import HybridLink from '../Generic/Links/HybridLink';
import useBellaTranslator from '../../hooks/useTranslator';
import { TrackHeaderActions } from '../../../common/ga/types';
import useGa from '../../hooks/useGa';
import { usePageResolver } from '../ListingPage/hooks/useTrackingPageLabel';

export const headerTabsLayoutCss = css`
    display: grid;
    place-items: center;
`;

const NowTabContent = styled(HybridLink)`
    grid-area: shoptab;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    box-shadow: -2px -2px 2px 0 rgba(0, 0, 0, 0.18);
    background: ${({ theme }) => theme.colors.white};
    color: ${({ theme }) => theme.colors.charcoal100};
    width: 50%;
    ${forDesktop`
        box-shadow: none;
        width: 188px;
    `}

    ${forIE`
        -ms-grid-row: 1;
        -ms-grid-row-span: 1;
        -ms-grid-column: 3;
        -ms-grid-column-span: 3;
        height: 46px;
        display: flex;
        flex-direction: column;
        align-items: center;
    `}
`;

const NowLogoText = styled.span`
    ${caption1}
    ${textEllipsisCss}
    line-height: 16.8px;
    margin-top: 2px;
    letter-spacing: 0;
    color: ${({ theme }) => theme.colors.charcoal100};
`;

const StyledWestwingNowLogo = styled(WestwingNowLogo)`
    height: 12px;
    display: block;
    margin-top: 8px;

    ${forDesktop`
        height: 13px;
        margin-top: 8px;
    `}

    ${forIE`
        width: 100%;
    `}

    ${forIPhone5`
        max-width: 118px;
    `}
`;

interface Props {
    fromBurgerMenu?: boolean;
    handleCloseBtnClick?: () => void;
}

const ShopTab: React.FC<Props> = ({ fromBurgerMenu, handleCloseBtnClick }) => {
    const {
        links: { home: HomeLink = '' },
    } = useConfig();
    const pageTypeLabel = usePageResolver();
    const t = useBellaTranslator();
    const ga = useGa();
    const handleNowTabClick = useCallback(() => {
        if (fromBurgerMenu && handleCloseBtnClick) {
            handleCloseBtnClick();
            ga.oneHeader.trackHeaderAction(
                'shoptabclick',
                TrackHeaderActions.HeaderShopLinkClickFromMenu,
                pageTypeLabel
            );
        } else {
            ga.oneHeader.trackHeaderAction('shoptabclick', TrackHeaderActions.HeaderShopTabClick, pageTypeLabel);
        }
    }, [fromBurgerMenu, ga.oneHeader, handleCloseBtnClick, pageTypeLabel]);
    return (
        <NowTabContent to={HomeLink} onClick={handleNowTabClick}>
            <StyledWestwingNowLogo />
            <NowLogoText>{t('Westwingnow tab subline - Header redesign')}</NowLogoText>
        </NowTabContent>
    );
};

export default ShopTab;
